import React, { Fragment, useState, useEffect, useRef } from "react";
import { PersonalDetails } from "./PersonalDetails";
import { translate } from "../../../Services/translation";
import { NearestOptician } from "./NearestOptician";
import { post, get } from "../../../Services/http";
import { LastLensCheckDate } from "./LastLensCheckDate";
import { BACKEND_LOGGEND_IN_SHOPID } from '../../../../Scripts/Backend/Services/Api.service';

export const RegistrationContainer = (props) => {
    let initialState = {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        address: '',
        zip: '',
        city: '',
        agreeToInformation: false,
        getOfferInformation: false,
        runOutofLenses: false,
        nearestOptician: '',
        within12months: false,
        lastLensCheckDate: '',
    }

    let initialErrorState = {
        firstName: false,
        lastName: false,
        phoneMandatory: false,
        phoneFormat: false,
        emailMandatory: false,
        emailFormat: false,
        address: false,
        zip: false,
        zipFormat: false,
        city: false,
        agreeToInformation: false,
        nearestOptician: false,
        lastLensCheckDate: false,
    }

    const loggedInShopId = localStorage.getItem(BACKEND_LOGGEND_IN_SHOPID);
    const isStoreChannel = ((props.optician !== null && props.optician !== '') || (loggedInShopId !== null && loggedInShopId !== ''));
    const [personalInfo, setPersonalInfo] = useState(initialState);
    const [validationErrors, setValidationErrors] = useState({});
    const [showPersonalDetailsSection, setshowPersonalDetailsSection] = useState(true);
    const [showNearestOpticianSection, setshowNearestOpticianSection] = useState(false);
    const [showLensCheckDateSection, setshowLensCheckDateSection] = useState(false);
    const [showError, setshowError] = useState(false);
    const [error, seterror] = useState("");
    const [phoneEditable, setphoneEditable] = useState(true);
    let errorInPersonalDetailsSection = false;
    let errorInNearestOpticianSection = false;
    let errorInLastLensCheck = false;    

    useEffect(() => {
        if (props.phoneNumber) {
            post(`/api/gdprapproval/getcustomer`, {
                phoneNumber: props.phoneNumber
            })
                .then((response) => response.json())
                .then((result) => {
                    setPersonalInfo({
                        ...personalInfo, agreeToInformation: result.agreeToInformation, getOfferInformation: result.getOfferInformation,
                        runOutofLenses: result.runOutofLenses, phone: result.phone, nearestOptician: loggedInShopId
                    });
                    setphoneEditable(false);                    
                });
        }
        if (isStoreChannel) {
            setSelectedStoreId(props.optician);
        }
    }, []);

    const onChange = (e) => {
        setPersonalInfo({ ...personalInfo, [e.target.name]: (e.target.type === "radio" || e.target.type === "checkbox") ? e.target.checked : e.target.value });
    };

    const setSelectedStoreId = (value) => {
        setPersonalInfo({ ...personalInfo, nearestOptician: value });
    };
    const setLastLensCheckDate = (value) => {
        const dateValue = new Date(value);
        setPersonalInfo({ ...personalInfo, lastLensCheckDate: `${String(dateValue.getDate()).padStart(2, '0')}-${String(dateValue.getMonth() + 1).padStart(2, '0')}-${dateValue.getFullYear()}` });
    };

    const setwithin12months = (value) => {
        if (!value) {
            errorInLastLensCheck = false;
            setPersonalInfo({ ...personalInfo, within12months: value, lastLensCheckDate: "" });
            setValidationErrors({ ...validationErrors, lastLensCheckDate: false });
        } else {
            setPersonalInfo({ ...personalInfo, within12months: value });
        }
    };

    const registerProfile = () => {
        if (validateData(true, true, true)) {
            post(`/api/register/`, {
                ...personalInfo
            })
                .then((response) => response.json())
                .then((result) => {
                    if (!result.isSuccessStatusCode) {
                        setshowError(true);
                        seterror(result.reasonPhrase);
                    }
                    else {
                        window.location.href = props.redirectUrl;
                    }
                });
        }
    }

    const validateData = (onlyPersonalDetails = false, onlyNearestOptician = false, onlyLastCheckDate = false) => {
        let validation = initialErrorState;
        const regexNorway = /^\d{8}$/;        
        var emailRegex = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;
        const regexZip = /^\d{4}$/;

        if (onlyPersonalDetails) {
            if (!personalInfo.firstName) {
                validation.firstName = true;
                errorInPersonalDetailsSection = true;
            }
            if (!personalInfo.lastName) {
                validation.lastName = true;
                errorInPersonalDetailsSection = true;
            }
            if (!personalInfo.phone) {
                validation.phoneMandatory = true;
                errorInPersonalDetailsSection = true;
            }
            else if (personalInfo.phone && !(regexNorway.test(personalInfo.phone))) {
                validation.phoneFormat = true;
                errorInPersonalDetailsSection = true;
            }
            if (!personalInfo.email) {
                validation.emailMandatory = true;
                errorInPersonalDetailsSection = true;
            }
            else if (personalInfo.email && !emailRegex.test(personalInfo.email)) {
                validation.emailFormat = true;
                errorInPersonalDetailsSection = true;
            }
            if (!personalInfo.address) {
                validation.address = true;
                errorInPersonalDetailsSection = true;
            }
            if (!personalInfo.zip) {
                validation.zip = true;
                errorInPersonalDetailsSection = true;
            }

            if (personalInfo.zip && !regexZip.test(personalInfo.zip)) {
                validation.zipFormat = true;
                errorInPersonalDetailsSection = true;
            }

            if (!personalInfo.city) {
                validation.city = true;
                errorInPersonalDetailsSection = true;
            }
            if (!personalInfo.agreeToInformation) {
                validation.agreeToInformation = true;
                errorInPersonalDetailsSection = true;
            }

            if (errorInPersonalDetailsSection) {
                setshowPersonalDetailsSection(true);
            }
        }

        if (onlyNearestOptician) {
            if (!personalInfo.nearestOptician) {
                validation.nearestOptician = true;
                errorInNearestOpticianSection = true;
            }

            if (errorInNearestOpticianSection) {
                setshowNearestOpticianSection(true);
            }
        }

        if (onlyLastCheckDate) {
            if (personalInfo.within12months && !personalInfo.lastLensCheckDate) {
                validation.lastLensCheckDate = true;
                errorInLastLensCheck = true;
            }

            if (errorInLastLensCheck) {
                setshowLensCheckDateSection(true);
            }
        }

        setValidationErrors(validation);
        if (Object.values(validation).some(x => x === true)) {
            return false;
        }
        return true;
    };
    const checkDateActive = showLensCheckDateSection ? "active" : "";
    const personalDetailsActive = showPersonalDetailsSection ? "active" : "";
    const nearestOptActive = showNearestOpticianSection ? "active" : "";

    const nearestOpticianRef = useRef(null);
    const lastLensCheckDateRef = useRef(null);

    useEffect(() => {
         if (showNearestOpticianSection) {
          nearestOpticianRef.current.scrollIntoView({ behavior: 'smooth' });
        } else if (showLensCheckDateSection) {
          lastLensCheckDateRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }, [showPersonalDetailsSection, showNearestOpticianSection, showLensCheckDateSection]);

    return (
        <Fragment>
            {showError && <div className="error">
                {error}
            </div>}
            <div className={`register__section-container ${personalDetailsActive}`} >
                <div className="register__header-container">
                    <div className="title">
                        <p>1.</p>
                        <p>
                            {translate('coptikk.register.fillininformationheader')}
                        </p>
                    </div>
                    {!showPersonalDetailsSection && personalInfo && personalInfo.firstName &&
                        <a onClick={() => {
                            setshowPersonalDetailsSection(!showPersonalDetailsSection);
                            setshowNearestOpticianSection(false);
                            setshowLensCheckDateSection(false);
                        }
                        }
                        >{translate("coptikk.register.editsection")}</a>}
                </div>
                {showPersonalDetailsSection &&
                    <>
                        <PersonalDetails onChange={onChange} validationErrors={validationErrors} data={personalInfo} phoneEditable={phoneEditable}></PersonalDetails>
                        <div className="row register__button-container">
                            <div className="column small-12">
                                <a className="button secondary" onClick={() => {
                                    validateData(true, false, false);
                                    if (!errorInPersonalDetailsSection) {
                                        setshowPersonalDetailsSection(!showPersonalDetailsSection);
                                        if (isStoreChannel) {
                                            setshowLensCheckDateSection(!showLensCheckDateSection);
                                        }
                                        else {
                                            setshowNearestOpticianSection(!showNearestOpticianSection);
                                        }
                                    }
                                }}>{translate('coptikk.register.nextbuttontext')}</a>
                            </div>
                        </div>
                    </>
                }
            </div>
            {!isStoreChannel &&
                <div className={`register__section-container ${nearestOptActive}`} ref={nearestOpticianRef}>
                    <div className="register__header-container">
                        <div className="title">
                            <p>2.</p>
                            <p>
                                {translate('coptikk.register.nearestopticianheader')}
                            </p>
                        </div>
                        {!showNearestOpticianSection && personalInfo && personalInfo.nearestOptician &&
                            <a onClick={() => {
                                setshowNearestOpticianSection(!showNearestOpticianSection);
                                setshowPersonalDetailsSection(false);
                                setshowLensCheckDateSection(false);
                            }}>{translate("coptikk.register.editsection")}</a>}
                    </div>
                    {validationErrors && validationErrors.nearestOptician && <div className="error">{translate("validation.required")} - {translate("coptikk.register.nearestopticianheader")}</div>}
                    {showNearestOpticianSection &&
                        <>
                            <NearestOptician setSelectedStoreId={setSelectedStoreId} selectedStoreId={personalInfo.nearestOptician}
                                validationErrors={validationErrors}></NearestOptician>
                            <div className="row register__button-container">
                                <div className="column small-12">
                                    <a className="button secondary" onClick={() => {
                                        validateData(false, true, false);
                                        if (!errorInNearestOpticianSection) {
                                            setshowNearestOpticianSection(!showNearestOpticianSection);
                                            setshowLensCheckDateSection(!showLensCheckDateSection);
                                        }
                                    }}>
                                        {translate('coptikk.register.nextbuttontext')}</a>
                                </div>
                            </div>
                        </>
                    }
                </div>
            }

            <div className={`register__section-container ${checkDateActive}`} ref={lastLensCheckDateRef}>
                <div className="register__header-container">
                    <div className="title">
                        {isStoreChannel && <p>2.</p>}
                        {!isStoreChannel && <p>3.</p>}
                        <p>
                            {translate("coptikk.register.lastlenscheckheader")}
                        </p>
                    </div>
                    
                    {!showLensCheckDateSection && personalInfo && personalInfo.lastLensCheckDate &&
                        <a onClick={() => {
                            setshowLensCheckDateSection(!showLensCheckDateSection);
                            setshowPersonalDetailsSection(false);
                            setshowNearestOpticianSection(false);
                        }
                        }>{translate("coptikk.register.editsection")}</a>}
                </div>
                {showLensCheckDateSection &&
                    <>
                        <LastLensCheckDate setLastLensCheckDate={setLastLensCheckDate} lastLensCheckDate={personalInfo.lastLensCheckDate}
                            validationErrors={validationErrors} within12months={personalInfo.within12months} setwithin12months={setwithin12months}></LastLensCheckDate>
                        <div className="row register__button-container">
                            <div className="column small-12">
                                <a className="button secondary" onClick={() => registerProfile()}>{translate('coptikk.register.completeregistration')}</a>
                            </div>
                        </div>
                    </>
                }
            </div>
        </Fragment>
    )
}